import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

function processSubmission(method, data, additionalHeaders = {}) {
    return JsonRPCService.send(getProxiedServiceUrl('reinstatement'), method, data, additionalHeaders);
}

export default class ReinstatementService {    
    static startReinstatement(dto, additionalHeaders = {}) {
        return processSubmission('startReinstatement', [dto], additionalHeaders);
    }
    
    static saveAndBindReinstatement(dto, additionalHeaders = {}) {
        return processSubmission('saveAndBindReinstatement', [dto], additionalHeaders);
    }
    
    static withdrawReinstatement(dto, additionalHeaders = {}) {
        return processSubmission('withdrawReinstatement', [dto], additionalHeaders);
    }
    
    static getJobData(jobID, additionalHeaders = {}) {
        return processSubmission('getJobData', [jobID], additionalHeaders);
    }
}
